import { ReactComponent as HeartOutline } from '@assets/icons/heart-outline.svg';
import { ReactComponent as HeartSolid } from '@assets/icons/heart-solid.svg';

import { Flex, FlexProps, IconButton } from '@chakra-ui/react';

// eslint-disable-next-line
const stopEvent = (event?: any) => event?.stopPropagation();

interface FavoriteIconButtonProps extends FlexProps {
  onClick: () => void;
  isFavorite: boolean;
  size: number;
  fill: string;
  isDisable: boolean;
}

const FavoriteIconButton = ({
  onClick,
  isFavorite,
  fill,
  size,
  isDisable,
  ...props
}: FavoriteIconButtonProps) => (
  <Flex h='full' alignItems='center' justifyContent='center' {...props}>
    <IconButton
      onClick={isDisable ? stopEvent : onClick}
      _focus={{
        bg: 'transparent'
      }}
      flexShrink={0}
      aria-label='Favorite product'
      icon={
        isFavorite ? (
          <HeartSolid fill={fill} width={size} height={size} />
        ) : (
          <HeartOutline fill={fill} width={size} height={size} />
        )
      }
      variant='ghost'
      px='10px'
      py='5px'
      height='100%'
    />
  </Flex>
);

export default FavoriteIconButton;
